import StartShell from "../StartShell";
import { Card } from "@repo/components/src/ui/card";
import { useState } from "react";
import { ScrollView } from "react-native";
import CheckEmail from "./CheckEmail";

type Props = {
  email: string;
  /** When the backend sends another link (epoch ms). */
  resendAt: number;
};

/**
 * «Revisa tu correo» for an email sign-up that outlived its page: the backend clears
 * the guest campaign at sign-up, so after a reload only the pending sign-up (see
 * `useGuestPendingSignUp`) says where the link went and when another can be sent.
 */
const PendingCheckEmail = ({ email, resendAt }: Props) => {
  const [currentEmail, setCurrentEmail] = useState(email);
  return (
    <StartShell>
      <ScrollView
        contentContainerClassName="grow items-center p-margins"
        showsVerticalScrollIndicator={false}
      >
        <Card variant="elevated" size="xl" className="w-full max-w-[480px]">
          <CheckEmail
            email={currentEmail}
            initialResendAt={resendAt}
            onEmailChanged={setCurrentEmail}
          />
        </Card>
      </ScrollView>
    </StartShell>
  );
};

export default PendingCheckEmail;
